<template>
  <div class="custom-tree-container">
    <el-row class="content-bottom-padded" style="padding-top:15px;margin-left:20px">
      <el-col>
        <el-button type="primary" icon="plus" @click="updateCategory" size="mini" :disabled="isDisable">保存主类目</el-button>
      </el-col>
    </el-row>
    <div class="block">
      <ul class="custom-tree-node-title">
        <li>类目名称</li>
      </ul>
    </div>
    <div class="tree-background block">
      <el-tree v-loading="loading" :data="categoryList" default-expand-all :expand-on-click-node="false">
        <ul class="custom-tree-node" slot-scope="{ node, data }">
          <li>
            <input placeholder="名称" v-model="data.category_name"/>
            <el-button type="text" v-if="data.category_level == 1 || data.category_level == 2" @click="append(data.children, data.category_level,data)">新增子类目</el-button>
          </li>
          <!--li class="category-icon">
            <span @click="handleImgChange(data)">
              <img v-if="data.image_url" :src="wximageurl + data.image_url"/>
              <i v-else class="iconfont icon-image"></i>
            </span>
          </li-->
          <span>
            <span style="padding-right:100px"><input style="width:50px" placeholder="排序" v-model="data.sort"/></span>
            <span :style="data.category_level==3 ? 'padding-right:100px' : 'padding-right:234px'" v-if="data.created">{{ data.created | datetime }}</span>
            <el-button type="text" v-if="data.category_level == 3 || data.category_level == 2" @click="handleDialogAttr(data, 'item_params', node)">关联参数</el-button>
            <el-button type="text" v-if="data.category_level == 3 || data.category_level == 2" @click="handleDialogAttr(data, 'item_spec', node)">关联规格</el-button>
            <router-link :to="{path: matchInternalRoute('goodsphysical'), query:{main_cat_id: data.category_id}}"> 查看商品 </router-link>
            <!-- 屏蔽删除类目-->
            <!--<span class="remove-category" @click="deleteCategory(node, data)">-->
              <!--<i class="iconfont icon-trash-alt"></i>-->
            <!--</span>-->
          </span>
        </ul>
      </el-tree>
      <div class="add-category">
        <span @click="append(categoryList)"><i class="el-icon-plus"></i>增加顶级类目</span>
      </div>
    </div>
    <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker></li>
  <el-dialog :title="(currentAttrType == 'item_params') ? '关联参数' : '关联规格'" :visible.sync="relAttrvisible"  :before-close="handleCancel">
    <el-alert
      title="关联说明"
      type="info"
      description="类目最多关联20个商品参数和5个规格，并且只能关联一个图片属性规格"
      show-icon>
    </el-alert>
    <el-row :gutter="10" v-loading="dialogLoading">
      <el-col :span="12">
        <el-table ref="multipleTable" :data="goodsAttr" style="width: 100%" tooltip-effect="dark" @select="handleSelectionChange" @select-all="selectAll">
          <el-table-column type="selection" width="55" > </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <span class="sku-value" v-for="(item, index) in props.row.attribute_values.list" :key="index"> <el-tag type="info"> {{item.attribute_value}}</el-tag></span>
            </template>
          </el-table-column>
          <el-table-column prop="attribute_name" label="全部">
            <template slot-scope="props">
              <span v-if="props.row.attribute_memo">{{props.row.attribute_name}}【{{props.row.attribute_memo}}】</span>
              <span v-else>{{props.row.attribute_name}}</span>
              <el-tag v-if="currentAttrType == 'item_spec' && props.row.is_image == 'true'" size="mini" type="success">图片</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-center content-top-padded">
        <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="attrParams.page"
              :page-sizes="[10,20,50]"
              :total="this.goodsAttrTotal"
              :page-size="attrParams.pageSize">
            </el-pagination>
        </div>
      </el-col>
      <el-col :span="12">
        <el-table :data="checkGoodsAttr" style="width: 100%">
          <el-table-column prop="attribute_name" :label="'已选择(' + this.checkGoodsAttr.length + ')'">
            <template slot-scope="props">
              <span v-if="props.row.attribute_memo">{{props.row.attribute_name}}【{{props.row.attribute_memo}}】</span>
              <span v-else>{{props.row.attribute_name}}</span>
              <el-tag v-if="currentAttrType == 'item_spec' && props.row.is_image == 'true'" size="mini" type="success">图片</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="saveCategoryAttr">确 定</el-button>
    </span>
  </el-dialog>
</div>
</template>
<script>
  import {getCategory, saveCategory, deleteCategory, updateCategory, getCategoryInfo} from '../../../api/goods'
  import { getGoodsAttr } from '@/api/goods'
  import imgPicker from '@/components/imageselect'

  export default {
    components: {
      imgPicker
    },
    data() {
      return {
        isDisable: false,
        loading: false,
        spaceInput: false,
        categoryList: [],
        total_count: 0,
        params: {
          is_main_category: true,
        },
        attrParams: {
          page: 1,
          pageSize: 20,
        },
        imgDialog: false,
        dialogLoading: false,
        isGetImage: false,
        relAttrvisible: false,
        goodsAttr: [],
        checkGoodsAttr: [],
        currentNode: 0,
        currentAttrType: '',
        goodsAttrTotal: 0,
        currentCategory: []
      }
    },
    methods: {
      handleCurrentChange (page) {
        this.attrParams.page = page
        this.getGoodsAttr()
      },
      handleSizeChange (pageSize) {
        this.attrParams.page = 1
        this.attrParams.pageSize = pageSize
        this.getGoodsAttr()
      },
      handleDialogAttr(data, type, node) {
        this.dialogLoading = true
        this.relAttrvisible = true
        this.currentAttrType = type
        this.currentNode = node
        this.currentCategory = data
        this.attrParams.page = 1
        this.attrParams.pageSize = 20
        if (this.currentAttrType == 'item_spec') {
          var checkIds = this.currentCategory.goods_spec
        } else {
          var checkIds = this.currentCategory.goods_params
        }
        this.getGoodsAttr(checkIds)
      },
      selectAll(data) {
        this.$message({ type: 'error', message: '绑定不支持全选' })
        this.toggleRowSelection()
      },
      toggleRowSelection() {
        this.$refs.multipleTable.clearSelection();

        var checkids = []
        this.checkGoodsAttr.forEach(item => {
          checkids.push(item.attribute_id)
        })

        this.goodsAttr.forEach(item => {
          if (checkids && checkids.indexOf(item.attribute_id) !== -1) {
            this.$refs.multipleTable.toggleRowSelection(item)
          }
        })
      },
      handleSelectionChange (val, row) {
        var findIndex = -1
        var visible = 1
        this.checkGoodsAttr.forEach((item, index) => {
          // 如果操作的数据在已选择中，则表示取消选择
          if (row.attribute_id == item.attribute_id) {
            findIndex = index
          } else {
            if (item.is_image === 'true' && row.is_image === 'true') {
              this.$message({ type: 'error', message: '只能绑定一个图片类型规格' })
              this.toggleRowSelection()
              visible = 0
            }
          }
        })

        if (!visible) {
          this.toggleRowSelection()
          return false
        }

        if (this.currentAttrType == 'item_params') {
          if (this.checkGoodsAttr.length >= 20 && findIndex == -1) {
            this.toggleRowSelection()
            this.$message({ type: 'error', message: '最多关联20个商品参数' })
            return false
          }
        } else {
          if (this.checkGoodsAttr.length >= 5 && findIndex == -1) {
            this.toggleRowSelection()
            this.$message({ type: 'error', message: '最多关联5个规格' })
            return false
          }
        }

        if (findIndex != -1) {
          this.checkGoodsAttr.splice(findIndex, 1)
        } else {
          this.checkGoodsAttr.push(row)
        }
      },
      async getGoodsAttr(checkids=[]) {
        if(checkids.length === 0) {
          this.checkGoodsAttr.forEach(item => {
            checkids.push(item.attribute_id)
          })
        }

        if (checkids.length > 0) {
          await getGoodsAttr({page: 1, pageSize: 100, attribute_type: this.currentAttrType, attribute_ids: checkids}).then(info => {
            this.checkGoodsAttr = info.data.data.list
          })
        }

        await getGoodsAttr({page: this.attrParams.page, pageSize: this.attrParams.pageSize, attribute_type: this.currentAttrType}).then(res => {
          this.goodsAttr = res.data.data.list
          this.goodsAttrTotal = res.data.data.total_count
        })

        this.goodsAttr.forEach(item => {
          if (checkids && checkids.indexOf(item.attribute_id) !== -1) {
            this.$refs.multipleTable.toggleRowSelection(item)
          }
        })
        this.dialogLoading = false
      },
      saveCategoryAttr() {
        var checkids = []
        this.checkGoodsAttr.forEach(item => {
          checkids.push(item.attribute_id)
        })

        if (this.currentAttrType == 'item_spec') {
          this.currentCategory.goods_spec = checkids
          var selectionData = {goods_spec: JSON.stringify(checkids)}
        } else {
          var selectionData = {goods_params: JSON.stringify(checkids)}
          this.currentCategory.goods_params = checkids
        }

        if (this.currentCategory.category_id) {
          updateCategory(this.currentCategory.category_id, selectionData).then(res => {
            this.$message({ type: 'success', message: '保存成功' })
            this.handleCancel()
            this.getCategory()
          })
        } else {
          this.handleCancel()
        }
      },
      handleCancel () {
        this.relAttrvisible = false
        this.dialogLoading = false
        this.attrParams.page = 1
        this.attrParams.pageSize = 20
        this.goodsAttr = []
        this.checkGoodsAttr = []
        this.currentAttrType = ''
        this.currentCategory = []
      },
      getCategory() {
        this.loading = true
        this.params.is_main_category =  true
        getCategory(this.params).then(response => {
          this.categoryList = response.data.data
          this.loading = false
          this.spaceInput = false
        })
      },
      updateCategory() {
        for (var i = 0; i < this.categoryList.length; i++) {
          for (var a = 0; a < this.categoryList.length - 1 - i; a++) {
            if(this.categoryList[a].category_name == this.categoryList[a+1].category_name) {
              this.$message({
                type: 'error',
                message: '同级类目名称不能相同'
              })
              return false
            }
          }

          if (!this.catNameCheck(this.categoryList[i].category_name)) {
            return false
          }

          for (var j = 0; j < this.categoryList[i].children.length; j++) {
            for (var b = 0; b < this.categoryList[i].children.length - 1 - j; b++) {
              if(this.categoryList[i].children[b].category_name == this.categoryList[i].children[b+1].category_name) {
                this.$message({
                  type: 'error',
                  message: '同级类目名称不能相同'
                })
                return false
              }
            }
            if (!this.catNameCheck(this.categoryList[i].children[j].category_name)) {
              return false
            }
          }
        }
        this.isDisable = true
        setTimeout(() => {
            this.isDisable = false
        }, 1000)
        let form = JSON.stringify(this.categoryList)
        saveCategory({form: form}).then(response => {
          this.$message({
            type: 'success',
            message: '保存类目成功'
          })
          this.getCategory()
        })
      },
      deleteCategory(node, data) {
        this.$confirm('此操作将删除该类目, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (typeof (data.category_id) != 'undefined') {
            deleteCategory(data.category_id).then(response => {
              this.$message({
                type: 'success',
                message: '删除类目成功'
              })
              this.getCategory()
            })
          } else {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex(d => d.id === data.id);
            children.splice(index, 1);
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      append(data, category_level= 0) {

        var new_category_level = category_level + 1
        const newChild = {
          category_name: '',
          sort: 0,
          category_level: new_category_level,
          children: [],
          created: -1,
          image_url: '',
          'is_main_category': true,
          goods_params: [],
          goods_params: []
        }

        data.push(newChild)

      },
      catNameCheck (catName) {
        let catNameLength = 0
        if(catName) {
          for (var i=0; i < catName.length; i++) {
            if (catName.charCodeAt(i) > 255) {
              catNameLength += 2;
            } else {
              catNameLength ++ ;
            }
          }
          if(catNameLength > 50) {
            this.$message({
              type: 'error',
              message: '类目名称长度最多25个汉字或50个字符'
            })
            return false
          }
          return true
        } else {
          this.$message({
            type: 'error',
            message: '类目不能为空'
          })
          return false
        }
      },
      handleImgChange (data) {
        this.imgDialog = true
        this.isGetImage = true
        this.current = data
      },
      pickImg (data) {
        if (!this.current.parent_id || this.current.parent_id == 0) {
          const index = this.categoryList.findIndex(d => d.id === this.current.id);
          this.categoryList[index].image_url = data.url
        } else {
          const findex = this.categoryList.findIndex(d => d.id === this.current.parent_id);
          const cindex = this.categoryList[findex].children.findIndex(d => d.id === this.current.id);
          this.categoryList[findex].children[cindex].image_url = data.url
        }
        this.imgDialog = false
      },
      closeImgDialog () {
        this.imgDialog = false
      },
    },

    mounted() {
      this.getCategory()
    }
  };
</script>

<style scoped lang="scss">

  .sku-value {
    margin-right: 10px;
  }

  .custom-tree-container {
    background-color: #fff;
  }

  .tree-background {
    padding-bottom: 45px;
    margin: 0px 20px;
  }

  .custom-tree-node, .custom-tree-node-title {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    li {
      display: inline-block;
      text-align: center;
      width: 25%;
    }
    li:first-child {
      text-align: left;
    }
    li.category-icon {
      display: flex;
      align-items: middle;
      justify-content: center;
      span {
        height: 30px;
      }
      img {
        width: auto;
        height: 30px;
      }
    }
  }

  .custom-tree-node-title {
    font-weight: bold;
    color: #909399;
    margin: 0px 20px;
    li {
      padding: 12px 0;
    }
  }

  .add-category {
    margin-left: 25px;
    margin-top: 30px;
    span {
      cursor: pointer;
    }
  }

  .remove-category {
    margin-left: 10px;
  }

  .add-child-category {
    margin-left: 10px;
  }
</style>
<style lang="scss">
  .custom-tree-container {
    .el-tree-node__content{
      height: 45px;
      padding: 0px;
      line-height: 45px;
    }
    .el-tree > .el-tree-node {
      position: relative;
      &::after {
        position: absolute;
        height: 1px;
        left: 0;
        right: 0;
        bottom: 0;
        content: "";
        background-color: #e6e6e6;
      }
    }
    .el-tree > .el-tree-node:first-child {
      &::before {
        position: absolute;
        height: 1px;
        left: 0;
        right: 0;
        top: 0;
        content: "";
        background-color: #e6e6e6;
      }
    }
  }

  .custom-tree-node {
    input {
      border: 1px solid #ddd;
      line-height: 25px;
      padding-left: 5px;
      width: 150px;
    }
  }

</style>



// WEBPACK FOOTER //
// maincategory.vue?a8da649e